import { makeStyles } from "@fluentui/react-components";
export const useMyTasksPageStyles = makeStyles({
    emptyStateRoot: {
        minHeight: "75vh"
    },
    viewToggle: {
        display: "flex",
        alignItems: "center"
    },
    pageLayoutRootForListView: {
        overflowY: "hidden"
    },
    // Narrow views have too little height left for the list once the page header and the view
    // transform bar have taken their share, so let the page itself scroll instead of pinning that
    // chrome. The header scrolls away and the content gets the full height.
    pageLayoutRootScrollable: {
        overflowY: "auto"
    },
    listViewContainer: {
        display: "flex",
        flexDirection: "column",
        flex: "1 1 0px",
        minHeight: 0,
        overflowY: "hidden"
    },
    // Grow to the content's natural height so the page root is what scrolls.
    listViewContainerNarrow: {
        flex: "0 0 auto",
        overflowY: "visible"
    }
});
